import { render } from "./CartCellUom.vue?vue&type=template&id=36dbe297"
import script from "./CartCellUom.vue?vue&type=script&lang=js"
export * from "./CartCellUom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__